import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import type { SurveyQuestion } from '../types/survey';

interface FeedbackPanelProps {
  question: SurveyQuestion;
  correct: boolean;
}

export function FeedbackPanel({ question, correct }: FeedbackPanelProps) {
  const rootRef = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      gsap.from('.feedback-panel > *', {
        opacity: 0,
        y: 16,
        duration: 0.45,
        stagger: 0.07,
        ease: 'power3.out',
      });
    },
    { scope: rootRef },
  );

  return (
    <div ref={rootRef} className="feedback-panel is-visible" role="status" aria-live="polite">
      <div className={`feedback-panel__status ${correct ? 'is-correct' : 'is-wrong'}`}>
        <span>{correct ? '✓' : '!'}</span>
        <span>{correct ? 'Bonne réponse !' : 'Pas tout à fait.'}</span>
      </div>
      <p className="feedback-panel__explanation">{question.explanation.fr}</p>
      <p className="feedback-panel__explanation ar" dir="rtl">{question.explanation.ar}</p>
      <div className="feedback-panel__tip">
        <strong>Conseil pratique · نصيحة</strong>
        <span>{question.tip.fr}</span>
        <span className="ar" dir="rtl">{question.tip.ar}</span>
      </div>
    </div>
  );
}
